import { CommonModule, CurrencyPipe, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { ClickOutsideDirective, FocusDirective, FullScreenDirective, HoverOverDirective, ShowOnScreenSizeDirective, UploadDirective } from './directives';
import {
  CastPipe,
  ClientPortalAuctionUrlPipe,
  ClientPortalDetailsUrlPipe,
  ClientPortalOverviewValuePipe,
  CountPipe,
  DayjsFormatPipe,
  DebouncePipe,
  DurationPipe,
  FilterPipe,
  FindControllPipe,
  FormattedCurrencyPipe,
  FormattedDatePipe,
  HtmlRemovePipe,
  LimitPipe,
  MatchesCategoryTypesPipe,
  PhoneNumberPipe,
  SafeHtmlPipe,
  SlugPipe,
  SortPipe,
  StringPipe,
  TextCasePipe,
} from './pipes';
import { RemoveHtmlPipe } from './pipes/remove-html.pipe';

// Pipes, Angular
// Pipes, Custom
// Directives

// Pipes + Directives
export const APP_PIPES_DIRECTIVES = [
  // Pipes
  CountPipe,
  DebouncePipe,
  PhoneNumberPipe,
  DurationPipe,
  FilterPipe,
  HtmlRemovePipe,
  SafeHtmlPipe,
  SlugPipe,
  SortPipe,
  StringPipe,
  TextCasePipe,
  LimitPipe,
  RemoveHtmlPipe,
  CastPipe,
  MatchesCategoryTypesPipe,
  DayjsFormatPipe,
  ClientPortalOverviewValuePipe,
  ClientPortalDetailsUrlPipe,
  ClientPortalAuctionUrlPipe,
  FindControllPipe,
  FormattedDatePipe,
  FormattedCurrencyPipe,

  // Directives
  FullScreenDirective,
  FocusDirective,
  ClickOutsideDirective,
  HoverOverDirective,
  UploadDirective,
  ShowOnScreenSizeDirective,
];

@NgModule({
  imports: [
    // Angular
    CommonModule,
  ],
  providers: [DatePipe, CurrencyPipe],
  declarations: [APP_PIPES_DIRECTIVES],
  exports: [APP_PIPES_DIRECTIVES],
  entryComponents: [],
})
export class SharedModule {}
